<template>
    <div ref="top" class="top">
    </div>
    <div class="form-panel input" id="results">
        <div id="close-bubble-results"></div>
        <header class="output-header">
            <h2>Value of Prescriptive Application<sup>*</sup></h2>
            <!-- <div class="net-values">
                <div v-for="(subItem) in netValue" :key="subItem.id">
                    <div class="label" id="info-label-rel">{{ subItem.label }}
                        <div class="info-bubble-rel" id="id-rel"><i>i<i>Calculated by subtracting the Performance Value Fee and the Prescriptive Zone Treatment Cost from the Revenue from Prescriptive Zones totals.</i></i></div>
                    </div>
                    <div v-bind:id="subItem.subId" class="sub-label"></div>
                </div>
            </div> -->

            <div id="header-results">
                <div class="net-values">
                    <div class="label uppercase">Annual Return From:
                        <br/>
                        <br/>
                    </div>
                </div>
                <div class="net-values">
                    <div v-for="(subItem) in netValue" :key="subItem.id" class="net-value" id="pa-results-header">
                        <div class="label" id="info-label-rel">Prescriptive</div>
                        <div class="sub-label">Application</div>
                        <div v-bind:id="subItem.id" class="result-field force-dollarsign">{{ subItem.value }}</div>
                    </div>

                    <div v-for="(subItem) in npNetValue" :key="subItem.id" class="net-value" id="npa-results-header">
                        <div class="label">Whole Field</div>
                        <div class="sub-label">Application</div>
                        <div v-bind:id="subItem.id" class="result-field force-dollarsign">{{ subItem.value }}</div>
                    </div>
                </div>
            </div>
            
            <ul class="tabs">
                <li id="tab-prescriptive-application" class="active-tab">Prescriptive Application</li>
                <li id="tab-non-prescriptive-application">Whole Field Application</li>
            </ul>
        </header>
        <div class="content active-container" id="pa-results">
            <!-- <div class="net-values">
                <div v-for="(subItem) in netValue" :key="subItem.id" class="net-value">
                    <div class="label" id="info-label-rel">{{ subItem.label }} Acres
                    <div class="info-bubble-rel" id="id-rel"><i>i<i>Calculated by subtracting the Agronomist Prescription Fee, the Performance Value Fee, and the Prescriptive Zone Treatment Cost from the Revenue from Prescriptive Zones.</i></i></div>
                    </div>
                    <div v-bind:id="subItem.subId" class="sub-label"></div>
                    <div v-bind:id="subItem.id" class="result-field">{{ subItem.value }}</div>
                </div>
            </div> -->
            <div class="details">
                <p><strong>Prescriptive Application Zones</strong> (Acres)</p>
                <!-- <p><strong>Field Size:</strong> <span id="fieldSize">125</span></p> -->
            </div>
            <div v-for="(item, index) in items" :key="item.id">
                
                <div class="result-field-headers" v-if="index === 0">
                    <div v-for="(subitem) in subItems" :key="subitem.id" class="result-field" v-bind:class="subitem.classes">
                        <span v-bind:id="setCategoryLabelId('p',subitem.id)" v-html="subitem.label"></span>
                    </div>
                </div>
                <div class="row" v-bind:class="item.classes" style="position: relative">
                    <label for="numrows"><strong>{{item.label}}</strong></label>
                    <div v-if="item.info" :class="'info-bubble-' + item.id" :id="'id-' + item.id"> <i>i<i v-html="item.info"></i></i> </div>
                    <div class="result-fields">
                        <div v-bind:[bindFieldId(item,subitem)]="getFieldId(item, subitem)" v-for="(subitem) in subItems" :key="subitem.id" v-bind:class="getFieldClasses(item, subitem)">
                            <input v-if="item.input && subitem.id != 'total'" type="number" v-bind:id="getFieldInputId(item, subitem)" v-bind:name="getFieldInputId(item, subitem)" v-bind:max="item.max" v-bind:min="item.min" v-bind:step="item.step">
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="content" id="npa-results">
            <!-- <div class="net-values">
                <div v-for="(subItem) in npNetValue" :key="subItem.id" class="net-value">
                    <div class="label">{{ subItem.label }} Acres</div>
                    <div v-bind:id="subItem.subId" class="sub-label"></div>
                    <div v-bind:id="subItem.id" class="result-field">{{ subItem.value }}</div>
                    <div class="sub-label bottom-label"></div>
                </div>
            </div> -->
            <div class="details">
                <p><strong>Whole Field Application Per&nbsp;Field</strong>&nbsp;(Acres)</p>
                <!--<p><strong>Field Size:</strong> <span id="fieldSize">125</span></p>-->
            </div>
            <div v-for="(item, index) in npItems" :key="item.id">
                <div class="result-field-headers" v-if="index === 0">
                    <div v-for="(subitem) in npSubItems" :key="subitem.id" class="result-field" v-bind:class="subitem.classes">
                        <span v-bind:id="setCategoryLabelId('np',subitem.id)" v-html="subitem.label"></span>
                    </div>
                </div>
                <div class="row" v-bind:class="item.classes" style="position: relative">
                    <label for="numrows"><strong>{{item.label}}</strong></label>
                    <div v-if="item.info" :class="'info-bubble-' + item.id" :id="'id-' + item.id"> <i>i<i v-html="item.info"></i></i> </div>
                    <div class="result-fields">
                        <div v-bind:[bindFieldId(item,subitem)]="getFieldId(item, subitem)" v-for="(subitem) in npSubItems" :key="subitem.id" v-bind:class="getFieldClasses(item, subitem)">
                            <input v-if="item.input && subitem.id != 'total'" type="number" v-bind:id="getFieldInputId(item, subitem)" v-bind:name="getFieldInputId(item, subitem)" v-bind:max="item.max" v-bind:min="item.min" v-bind:step="item.step">
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="print-results">
            <div class="content">
                <div class="blue" id="print-btn" @click="scrollToTop()">
                    <img src="@/assets/images/icon_print.png" alt="Print Icon"/>PRINT RESULTS
                </div>
                <p>Share your results with your crop inputs retailer to get a quote and determine the exact ROI for your operation.</p>
                <p>*This is only an estimate, not a yield guarantee. Fee for prescription services is not included.</p>
                <!-- <h4>Want to save even more?</h4>
                <p>If you purchase a SIMPAS system before May 1, 2021, you'll earn 30% off all eligible SIMPAS-applied Solutions throughout this season. You'll also be eligible to receive product discounts for the 2022 and 2023 seasons.</p>
                <a href="https://www.simpas.com/offer/" class="btn blue" target="_blank" rel="noopener noreferrer">Save an Extra&nbsp;30%</a> -->
            </div>
        </div>
    </div>

    <div class="triangle triangle-output">
        <svg class="tri-desk" width="30" height="101" viewBox="0 0 30 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30 50.3787L7.45453e-07 100.379L-4.47035e-07 0.378655L30 50.3787Z" fill="#19457F"/>
        </svg>
        <svg class="tri-mobile" width="100" height="31" viewBox="0 0 100 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M50 30.3787L1.07281e-05 0.378659L100 0.378662L50 30.3787Z" fill="#19457F"/>
        </svg>
    </div>
</template>


<script>
import InputForm from './InputForm.vue';
// @ is an alias to /src
export default {
  name: 'OutputForm',
  components: {
  },
  mixins: [
    InputForm
  ],
  data() {
    return {
      parentMessage: 'Parent',
      netValue: [
        { id: 'netValueWhole', label: 'Annual Net Value', subId: 'resNumAcres', value: '', info: 'This field is editable. Manually updating the Average Yield Increase Per Acre fields will change to the results above.' }//,
       // { id: 'netValueTreatment', label: 'Net Value Per Field', subId: 'resFieldSize', value: '' }
      ],
      items: [
        { id: 'prescriptiveZoneAcres', label: '', classes: 'large' },
        { id: 'yieldIncrease', label: 'Average Yield Increase Per Acre', classes: 'small', input: true, min: 0, max: 999, step: 1, info: 'Manually updating the Average Yield Increase Per Acre fields will change to the results above.' },
        { id: 'revenueLossFromNonTreatment', label: 'Revenue Loss from Nontreatment', classes: 'small' },
        //{ id: 'fee', label: 'Agronomist/Retailer Prescription Fee', classes: 'small' },
        { id: 'costToTreatPrescriptiveZone', label: 'Prescriptive Zone Treatment Cost', classes: 'small' },
        { id: 'revenueFromPrescriptiveZone', label: 'Revenue from Prescriptive Zones', classes: 'small' },
        // { id: 'performanceValueFee', label: 'Performance Value Fee', classes: 'small', info: 'Instead of a flat rate technology fee, a 25% Performance Value Fee is added if the yield benefit is greater than the treatment cost. The fee is calculated based on incremental yield from Prescriptive Zones less Prescriptive Zone Treatment Costs x 25%.' },
        { id: 'netValueWhole', label: 'Annual Net Value', classes: 'small' },
      ],
      subItems: [
        { id:'need1', label: '', classes: 'green' },
        { id:'need2', label: '', classes: 'yellow' },
        { id:'need3', label: '', classes: 'blue' },
        { id:'total', label: 'Total', classes: 'white' }
      ],
      npNetValue: [
        { id: 'np_netValueWhole', label: 'Net Value Total Farm', subId: 'np_resNumAcres', value: '' }//,
       // { id: 'netValueTreatment', label: 'Net Value Per Field', subId: 'resFieldSize', value: '' }
      ],
      npItems: [
        { id: 'np_prescriptiveZoneAcres', label: '', classes: 'large' },
        { id: 'np_yieldIncrease', label: 'Average Yield Increase Per Acre', classes: 'small', input: true, min: 0, max: 999, step: 1, info: 'This field is editable. Manually updating the Average Yield Increase Per Acre fields will change to the results above.' },
        { id: 'np_revenueLossFromNonTreatment', label: 'Revenue Loss from Nontreatment', classes: 'small' },
        { id: 'np_costToTreatEntireField', label: 'Non-Prescriptive Whole Field Application Cost', classes: 'small' },
        { id: 'np_revenueFromPrescriptiveZone', label: 'Revenue from Prescriptive Zones', classes: 'small' },
        //{ id: 'netValuePerField', label: 'Net Value Per Field', classes: 'small' },
        { id: 'np_netValueWhole', label: 'Annual Net Value', classes: 'small' },
      ],
      npSubItems: [
        { id:'need1', label: '', classes: 'green' },
        { id:'need2', label: '', classes: 'yellow' },
        { id:'need3', label: '', classes: 'blue' },
        { id:'total', label: 'Total', classes: 'white' }
      ]
    }
  },
    methods: {
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        setCategoryLabelId(pres,label){
            return pres + '_' + label;
        },
        getFieldClasses(item, subitem) {
            return (item.input && subitem.id != 'total' ? 'field' : 'result-field') + ' ' + subitem.classes;
        },
        getFieldId(item, subitem) {
            return item.input && subitem.id != 'total' ? '' : subitem.id + '_' + item.id;
        },
        getFieldInputId(item, subitem) {
            return subitem.id + '_' + item.id;
        },
        bindFieldId(item, subitem) {
            return item.input && subitem.id != 'total' ? '' : 'id';
        }
    },
    mounted: function() {

        // We should set default labels until they are overwritten by the user selections
        document.getElementById('p_need1').innerHTML = "Select Need";
        document.getElementById('p_need2').innerHTML = "Select Need";
        document.getElementById('p_need3').innerHTML = "Select Need";
        document.getElementById('np_need1').innerHTML = "Select Need";
        document.getElementById('np_need2').innerHTML = "Select Need";
        document.getElementById('np_need3').innerHTML = "Select Need";

        var results_id1 = document.getElementById("id-yieldIncrease");
        var results_id3 = document.getElementById("id-np_yieldIncrease");
        // var results_id4 = document.getElementById("id-performanceValueFee");
        // var results_id5 = document.getElementById("id-rel");
        var results_closeBubble = document.getElementById("close-bubble-results");

        results_closeBubble.addEventListener('click', function (cb) {
            results_id1.classList.remove('active-bubble');
            results_id3.classList.remove('active-bubble');
            results_closeBubble.style.display = "none";
            cb.preventDefault();
        });

        results_id1.addEventListener('click', function (e1) {
            results_id3.classList.remove('active-bubble');
            results_closeBubble.style.display = "block";
            results_id1.classList.add('active-bubble');
            e1.preventDefault();
        });

        results_id3.addEventListener('click', function (e1) {
            results_id1.classList.remove('active-bubble');
            results_closeBubble.style.display = "block";
            results_id3.classList.add('active-bubble');
            e1.preventDefault();
        });


        function cloneAndFormatData(source) {
            var src = source;
            var srcAmount = document.querySelector('#' + src.id + '-header .result-field').innerText;
            // var srcTotalAcres = document.querySelector('#resNumAcres').innerText;
            
            // Create new div
            const newDiv = document.createElement("div");
            newDiv.className = "application-results-header";
            newDiv.innerHTML = '<div class="label">Annual Net Value Total Farm</div>';
            // newDiv.innerHTML += '<div id="resNumAcres" class="sub-label">' + srcTotalAcres + '</div>';
            newDiv.innerHTML += '<div id="netValueWhole" class="result-field force-dollarsign">' + srcAmount + '</div>';
            // newDiv.innerHTML += '<div class="details"><h3>DETAILS</h3></div>';

            // Create a copy of it
            var clone = src.cloneNode(true);
            clone.prepend(newDiv);
            return clone;
        }

        function cloneAndPlace(source, destination) {
            // Get the elements
            var src = document.querySelector(source);
            var dest = document.querySelector(destination);
            // Format & create a copy of it
            // var clone = src.cloneNode(true);
            var clone = cloneAndFormatData(src);

            // Update the ID and add a class
            clone.id = '#pa-results-print';
            clone.classList.add('printable');
            // Inject it into the DOM
            dest.innerHTML = '';
            dest.appendChild(clone);
            document.querySelector('#app').classList.add('show-print-view');
        }

        function numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            //return x.toString().split('.')[0] + '.' + x.toString().split('.')[1].toFixed(2);
        }

        function setPrintInputLabels(src, dst, prefix, suffix) {
            var value = document.getElementById(src);
            var text = value.options[value.selectedIndex].text;
            document.getElementById(dst).innerHTML = prefix + text + suffix;
        }

        function setPrintInputValue(src, dst, prefix, suffix, dp) {
            var value = +document.getElementById(src).value;
            document.getElementById(dst).innerHTML = prefix + numberWithCommas(value.toFixed(dp)) + suffix;
        }
        
        function setPrintInputValues() {
            setPrintInputLabels('needOne', 'printNeed1Label', '', '');
            setPrintInputLabels('needTwo', 'printNeed2Label', '', '');
            setPrintInputLabels('needThree', 'printNeed3Label', '', '');
            setPrintInputLabels('crop', 'printCropLabel', '', '');

            setPrintInputValue('numacres', 'printNumAcres', '', '', 0);
            setPrintInputValue('need1pcg', 'printNeed1Pcg', '', '%', 0);
            setPrintInputValue('need2pcg', 'printNeed2Pcg', '', '%', 0);
            setPrintInputValue('need3pcg', 'printNeed3Pcg', '', '%', 0);
            //setPrintInputValue('fee', 'printFee', '$', '', 2);
            setPrintInputValue('price', 'printPrice', '$', '/Bushel', 2);
        }

        const printbtn = document.getElementById("print-btn");
        printbtn.addEventListener('click', function(pv) {
            document.querySelector('html').classList.add('print');
            document.querySelector('#app').classList.add('show-print-view');
            setPrintInputValues();
            cloneAndPlace('#pa-results', '#place-pa-data');
            cloneAndPlace('#npa-results', '#place-npa-data');
            window.print();
            pv.preventDefault();
        }, false);

        const pa = document.getElementById("tab-prescriptive-application");
        pa.addEventListener('click', function(e1) {
            document.querySelector('#tab-non-prescriptive-application').classList.remove('active-tab');
            document.querySelector('#tab-prescriptive-application').classList.add('active-tab');
            document.querySelector('#npa-results').classList.remove('active-container');
            document.querySelector('#pa-results').classList.add('active-container');
            e1.preventDefault();
        }, false);

        const npa = document.getElementById("tab-non-prescriptive-application");
        npa.addEventListener('click', function(e2) {
            document.querySelector('#tab-prescriptive-application').classList.remove('active-tab');
            document.querySelector('#tab-non-prescriptive-application').classList.add('active-tab');
            document.querySelector('#pa-results').classList.remove('active-container');
            document.querySelector('#npa-results').classList.add('active-container');
            e2.preventDefault();
        }, false);

        this.displayForms();
        this.calculate();
    }
}
</script>
